import { render, staticRenderFns } from "./AnnotationReminder.vue?vue&type=template&id=5ca7196e&"
import script from "./AnnotationReminder.vue?vue&type=script&lang=js&"
export * from "./AnnotationReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports